import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d8c1cedc")

_pushScopeId("data-v-d8c1cedc")
const _hoisted_1 = {
  key: 0,
  class: "col-12"
}
const _hoisted_2 = { class: "row edit-row" }
const _hoisted_3 = { class: "col-6 mx-auto" }
const _hoisted_4 = { class: "form-text small-text" }
const _hoisted_5 = {
  key: 1,
  class: "col-12"
}
const _hoisted_6 = { class: "row edit-row" }
const _hoisted_7 = { class: "editing-title" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "row edit-row" }
const _hoisted_10 = { class: "editing-wrapper" }
const _hoisted_11 = { class: "text-r" }
const _hoisted_12 = {
  class: "col-12",
  style: {"margin-block":"12px"}
}
const _hoisted_13 = {
  key: 1,
  class: "text-area-length"
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("/100")
const _hoisted_15 = { class: "row edit-row popup-two-buttons" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "col-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Multiselect = _resolveComponent("Multiselect")

  return (_openBlock(), _createBlock("div", {
    class: ["container popup-container", $setup.currentType === 'long-description' ? 'long' : 'short'],
    id: "edit-long-desciption"
  }, [
    _createVNode(_Transition, { name: "help" }, {
      default: _withId(() => [
        ($setup.showInfo)
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("div", {
                  class: ["editing-wrapper", $setup.currentType === 'long-description' ? 'long-description' : '']
                }, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode("small", _hoisted_4, _toDisplayString(_ctx.$t('help.aboutTranslation')), 1),
                    _createVNode("i", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showInfo = !$setup.showInfo)),
                      class: "icon-f icon-arrow-back fs-28"
                    })
                  ])
                ], 2)
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  ($setup.currentType === 'businessClientName')
                    ? (_openBlock(), _createBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('businessClient.name')), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("i", {
                      class: "icon-f icon-info fs-20 p-3",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showInfo = !$setup.showInfo))
                    })
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode(_component_Multiselect, {
                      label: "name",
                      modelValue: $setup.selectedOption,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($setup.selectedOption = $event)),
                      options: $setup.langs,
                      canDeselect: false,
                      valueProp: "id",
                      searchable: false,
                      onSelect: _ctx.selectLanguage
                    }, null, 8, ["modelValue", "options", "onSelect"])
                  ]),
                  ($setup.currentType === 'businessClientName')
                    ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList($setup.translations, (translation, translationIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          key: translationIndex,
                          class: "col-12"
                        }, [
                          (translation.languageId === $setup.selectedOption)
                            ? _withDirectives((_openBlock(), _createBlock("textarea", {
                                key: 0,
                                name: "",
                                id: "businessClientName",
                                cols: "30",
                                rows: "10",
                                class: "bookit-textarea product-textarea resize-off long-description",
                                maxlength: "100",
                                "onUpdate:modelValue": ($event: any) => (translation.name = $event),
                                onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.checkDescription('businessClientName')))
                              }, null, 40, ["onUpdate:modelValue"])), [
                                [_vModelText, translation.name]
                              ])
                            : _createCommentVNode("", true),
                          (translation.languageId === $setup.selectedOption)
                            ? (_openBlock(), _createBlock("span", _hoisted_13, [
                                _createVNode("span", {
                                  class: { 'length-limit': translation.name.length > 99 }
                                }, _toDisplayString(translation.name.length), 3),
                                _hoisted_14
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, [
                  _createVNode("button", {
                    class: "save-button-wrapper popup-bookit-button",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.saveTranslation && $setup.saveTranslation(...args))),
                    type: "button"
                  }, _toDisplayString(_ctx.$t('button.save')), 1)
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("button", {
                    class: "close-button-wrapper popup-bookit-button",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.goBack && $setup.goBack(...args))),
                    type: "button"
                  }, _toDisplayString(_ctx.$t('button.close')), 1)
                ])
              ])
            ]))
      ]),
      _: 1
    })
  ], 2))
})